import { useTermsList } from '@/features/apply-event/hooks/useTerms';
import { isEventRequiredTerms } from '../types/terms';

export default function useEventRequiredTerms() {
  const termsList = useTermsList();

  return termsList.filter(
    (terms) => !terms.isAgreed && isEventRequiredTerms(terms.category),
  );
}
